var exports = {
  "rx": "x234b8571--0b13b7--introduction",
  "jD": "x234b8571--0b13b7--breadcrumbs",
  "Sl": "x234b8571--0b13b7--image",
  "W_": "x234b8571--0b13b7--poster",
  "aw": "x234b8571--0b13b7--slider",
  "Qs": "x234b8571--0b13b7--content",
  "CO": "x234b8571--0b13b7--content-slider",
  "ai": "x234b8571--0b13b7--content--with-disclaimer",
  "tZ": "x234b8571--0b13b7--content--small",
  "XS": "x234b8571--0b13b7--content__wrapper",
  "yY": "x234b8571--0b13b7--disclaimer-wrapper",
  "PD": "x234b8571--0b13b7--developer",
  "WU": "x234b8571--0b13b7--developer-info",
  "M3": "x234b8571--0b13b7--contacts",
  "wm": "x234b8571--0b13b7--logo",
};

module.exports = exports;
